"use client";

import { useEffect, useRef, useState } from "react";
import { Captions, Play, Pause, Youtube } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function YoutubeSection() {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(true);
  const [captionsOn, setCaptionsOn] = useState(false);
  const prefersReducedMotion = useReducedMotion();
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    if (prefersReducedMotion) {
      video.pause();
      setIsPlaying(false);
    } else {
      video.play().catch(() => setIsPlaying(false));
    }
  }, [prefersReducedMotion]);
  const togglePlay = () => {
    const video = videoRef.current;
    if (!video) return;
    if (video.paused) {
      video.play().catch(() => {});
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }
  };
  const toggleCaptions = () => {
    const video = videoRef.current;
    if (!video) return;
    const tracks = video.textTracks;
    const next = !captionsOn;
    for (let i = 0; i < tracks.length; i++) {
      tracks[i].mode = next ? "showing" : "hidden";
    }
    setCaptionsOn(next);
  };
  return;
}